module.exports = __webpack_public_path__ + "static/media/beach_sports_icon.e63e008b.svg";